import { Injectable } from '@angular/core';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Injectable({ providedIn: 'root' })
export class PDFService {
    constructor() {
    }


    generatePdf(objDataVenta: any) {
        const documentDefinition = {
            pageSize: {
                width: 225,
                height: 'auto'
            },
            pageMargins: [10, 0, 10, 0],
            styles: {
                Header: {
                    fontSize: 9,
                    bold: true,
                    alignment: 'center'
                },
                BodyCenter: {
                    fontSize: 9,
                    alignment: 'center'
                },
                BodyLeft: {
                    fontSize: 9,
                    alignment: 'left'
                },
                TableLeft: {
                    fontSize: 8,
                    alignment: 'left'
                },
                centertme:
                {
                    alignment: 'center'
                }

            },
            pageOrientation: 'portrait',
            content: [
                { text: '\n', style: 'BodyCenter' },

                { text: 'Recibo Interno', style: 'Header' },
                this.getTituloFactura("Datos del Emisor"),
                { text: objDataVenta.venta.cuentaCorrienteColegio.nombre, style: 'Header' },
                { text: objDataVenta.venta.cuentaCorrienteColegio.direccion, style: 'BodyCenter' },
                { text: 'Tel:' + objDataVenta.venta.cuentaCorrienteColegio.telefono1 +
                (objDataVenta.venta.cuentaCorrienteColegio.telefono2 ? ' / ' + objDataVenta.venta.cuentaCorrienteColegio.telefono2 : ''), style: 'BodyCenter' },
                { text: '\n', style: 'BodyCenter' },
                this.getTituloFactura("Datos del Comprador"),
                { text: 'Fecha:' + objDataVenta.venta.fechaRegistro, style: 'BodyLeft' },
                { text: 'Nit: ' + objDataVenta.venta.nit, style: 'BodyLeft' },
                { text: 'Nombre: ' + objDataVenta.venta.razonSocial, style: 'BodyLeft' },
                { text: '\n', style: 'BodyCenter' },
                this.getTituloFactura("Datos del Recibo"),
                { text: 'Número: ' + objDataVenta.venta.correlativoInterno, style: 'BodyLeft' },
                // { text: 'Autorización: D5054566-3B07-4960-A3A0-F65C39340017', style: 'BodyLeft' },
                // { text: 'Fecha Certificación: 2021-05-22T09:25:15-06', style: 'BodyLeft' },
                // { text: 'Sujeto a pagos trimestrales ISR', style: 'BodyLeft' },
                { text: '\n', style: 'BodyCenter' },
                this.getTituloFactura("Detalle del Recibo"),
                {
                    layout: this.getLayoutTabla().layout,
                    table: {
                        headerRows: 1,
                        widths: [35, 70, 35, 35],
                        body: this.getDetallefactura(objDataVenta)
                    }
                },
                { text: '\n\n', style: 'BodyCenter' },
                // this.getTituloFactura("Datos del Sistema"),
                // { text: 'Plataforma: SimplyGT', style: 'BodyLeft' },
                // { text: 'Certificador: Inforum Consulting', style: 'BodyLeft' },
                // { text: 'NIT: 43430775', style: 'BodyLeft' },
                { text: '\n\n\n', style: 'BodyCenter' }
            ]
        };
        pdfMake.createPdf(documentDefinition).print();
    }

    getLayoutTabla() {
        return {
            layout: {
                // code from lightHorizontalLines:
                hLineWidth: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                        return 0;
                    }
                    return (i === node.table.headerRows) ? 2 : 1;
                },
                vLineWidth: function (i) {
                    return 0;
                },
                hLineColor: function (i) {
                    return i === 1 ? 'black' : '#aaa';
                },
                paddingLeft: function (i) {
                    return i === 0 ? 0 : 3;
                },
                paddingRight: function (i, node) {
                    return (i === node.table.widths.length - 1) ? 0 : 3;
                },
                // code for zebra style:
                fillColor: function (i, node) {
                    // return (i % 2 === 0) ? '#CCCCCC' : null;
                }
            }
        }
    }

    getTituloFactura(titulo: String) {
        return {
            layout: this.getLayoutTabla().layout,
            table: {
                headerRows: 1,
                widths: ['*'],
                body: [
                    [{ text: titulo, style: 'BodyCenter' }],
                    [{ text: '', style: 'BodyCenter' }],
                ]
            }
        };
    }

    getDetallefactura(DataVenta: any) {
        let BodyTable = [];
        BodyTable.push([
            { text: 'Cantidad', style: 'TableLeft' },
            { text: 'Descripción', style: 'TableLeft' },
            { text: 'Precio', style: 'TableLeft' },
            { text: 'SubTotal', style: 'TableLeft' }
        ]);
        for (const Detalle of DataVenta.venta.detalleVenta) {
            BodyTable.push([
                { text: Detalle.cantidad, style: 'TableLeft' },
                { text: Detalle.servicio.nombre, style: 'TableLeft' },
                { text: Detalle.precioVenta, style: 'TableLeft' },
                { text: Detalle.subtotal, style: 'TableLeft' }
            ]);
        }
        BodyTable.push(['', '', { text: 'Total', style: 'TableLeft' }, { text: DataVenta.venta.total, style: 'TableLeft' }]);
        return BodyTable;
    }

    getBase64(event) {
        let me = this;
        let file = event;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            //me.modelvalue = reader.result;
            console.log(reader.result);
            return reader.result;
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    getNotasUnidadPDF(obj: any) {

        var dd = function generador({  objGrado, logo, nombre,  unidades, materias, notaMin }) {


    // PARA CADA UNIDAD UNA TABLA
      // PARA CADA UNIDAD UNA TABLA
    const unidadesConNotas = unidades.filter(u => (u.notas || []).length > 0);
    const unidadTablas = unidadesConNotas
        .map((unidad, index) => {
            // Encabezados dinámicos
            const tableHeaders = [
                { text: 'Estudiante', style: 'tableHeader' },
                ...materias.map(m => ({ text: m.nombre, style: 'tableHeader', alignment: 'center' })),
                { text: 'Promedio', style: 'tableHeader', alignment: 'center' }
            ];
    
            // Filas
            const tableRows = unidad.notas.map(notaObj => [
                { text: notaObj.estudiante, style: 'studentCell' },
                ...materias.map(m => ({
                    text: notaObj[m.id] ?? '',
                    alignment: 'center',
                    color:(notaObj[m.id]||0)<notaMin? 'red': 'black' 
                })),
                { text: notaObj.promedio, alignment: 'center', bold: true, color:notaObj.promedio<notaMin? 'red': 'black' }
            ]);
               const tamano = obj.materias.length;
               let definido = 40;
                 if(tamano<=13){
                   definido = 540/tamano
                 }else{
                    const cantidad = tamano-13;
                    definido = ( 540+(50*cantidad))/tamano
                 }
    
            const elementos:any = [
                {
                    columns: [
                        {
                            // LOGO: reemplaza 'logoBase64' por tu imagen
                            image: 'logoBase64',
                            width: 70,
                            height: 70,
                            margin: [0, 0, 20, 0]
                        },
                        [
                            { text: nombre, style: 'tituloColegio', margin: [0, 0, 0, 4] },
                            { text: `Grado: ${objGrado.gradoNombre} ${objGrado.seccionNombre}`, style: 'subtitulo' },
                            { text: `Carrera: ${objGrado.carreraNombre}`, style: 'subtitulo' },
                            { text: `Ciclo: ${objGrado.cicloNombre}`, style: 'subtitulo' },
                        ]
                    ],
                    columnGap: 10,
                    margin: [0, 0, 0, 6]
                },
                { text: unidad.nombre, style: 'tableTitle', margin: [0, 20, 0, 8] },
                {
                    table: {
                    dontBreakRows: true,

                        headerRows: 1,
                        widths: [150, ...Array(materias.length).fill(definido), definido],
                        body: [tableHeaders, ...tableRows],
                        
                    },
                    layout: {
                        fillColor: (rowIdx) => (rowIdx === 0 ? '#F3F3F3' : null)
                    }
                }
            ];
    
            // Solo agregar pageBreak si NO es el último elemento
            if (index < unidadesConNotas.length - 1) {
                elementos.push({ text: '', pageBreak: 'after' });
            }
    
            return elementos;
        });
        const tamano = obj.materias.length;
        let definido = 0
        if(tamano>13){
         const cantidad = tamano-13;
            definido = 50*cantidad;
        }
        
    // DOCUMENT DEFINITION
    return {
     pageSize: {
            width: 936+definido,
            height: 612
        },
        pageOrientation: 'landscape',
        content: [
            ...unidadTablas.flat()
        ],
        images: {
            // Reemplaza por tu logo en base64, ejemplo: logoBase64: 'data:image/png;base64,iVBORw0...'
            logoBase64: "./tmp/" + logo
        },
        styles: {
            tituloColegio: { fontSize: 18, bold: true },
            subtitulo: { fontSize: 12, margin: [0, 2, 0, 0] },
            tableTitle: { fontSize: 14, bold: true, margin: [0, 6, 0, 6] },
            tableHeader: { fontSize: 7, bold: true, fillColor: '#E0E0E0', margin: [0, 2, 0, 2] },
            studentCell: { fontSize: 8, margin: [0, 2, 0, 2] }
        },
        defaultStyle: {
            fontSize: 9
        },
        pageMargins: [20, 40, 40, 40]
    };
}(obj);


    pdfMake.createPdf(dd).print();
    }



}
